export function objectToQueryString(data: { [key: string]: string | number | boolean }): string {
	// Convert an object to a query string
	return Object.keys(data)
		.reduce((queryString: string[], key: string) => {
			const value = data[key];
			if (value !== null && typeof value !== 'undefined') {
				return queryString.concat(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
			}
			return queryString;
		}, [])
		.join('&');
}
